import { EpimsBaseEntityDto } from './epim-base.dto';

import { IsNotEmpty } from 'class-validator';

export class ProgressHistoryReportDto extends EpimsBaseEntityDto {

               ProgressHistoryId: string;
                 ProgressReportId: string;
  @IsNotEmpty() ProjectActivityId: string;
  @IsNotEmpty() ProjectActivityProgress: number;
  @IsNotEmpty() ProjectActivityReport: number;
  @IsNotEmpty() ProgressReportTie: string;
  @IsNotEmpty() ProjectId: string;
                ReportNote: string;
                ProjectActivityName: string;

}
